export  const getReferrer = () => {
  return window.location.pathname
}


